
import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { format, subMinutes } from 'date-fns'
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ParkingRepo {
  constructor(
    private translateService: TranslocoService
  ) {
    this.translateService.selectTranslate('PLACEHOLDER.1_HOUR_BEFORE').pipe(take(1)).subscribe(value => { });
  }

  public createParkingStartTimeOptions(startTime: string) {
    let options: any = []
    let time = 0;
    const translations = [
      'TIME.1_HOUR_BEFORE',
      'TIME.1.25_HOUR_BEFORE',
      'TIME.1.5_HOUR_BEFORE',
      'TIME.1.75_HOUR_BEFORE',
      'TIME.2_HOURS_BEFORE',
      'TIME.2.25_HOURS_BEFORE',
      'TIME.2.5_HOURS_BEFORE',
      'TIME.2.75_HOURS_BEFORE',
      'TIME.3_HOURS_BEFORE',
      'TIME.3.25_HOURS_BEFORE',
      'TIME.3.5_HOURS_BEFORE',
      'TIME.3.75_HOURS_BEFORE',
      'TIME.4_HOURS_BEFORE',
      'TIME.4.25_HOURS_BEFORE',
      'TIME.4.5_HOURS_BEFORE'
    ]
    
    translations.forEach(element => {
      time = time == 0 ? 60 : time + 15;
      const val = subMinutes(startTime, time)
      options.push({
        value: format(val, "HH:mm"),
        datetime: val,
        viewValue: this.translateService.translate('PARKIFLY.CLOCK_SHORT') + ': ' + format(val, "HH:mm") + ' ' + this.translateService.translate('PARKIFLY.' + element)
      })
    });
    return options.reverse();
  }
}
